import React, { useState } from 'react'
import './Projects.css'
import marie from "../Assets/mariemadeit.png"
import prestige from "../Assets/prestige.png"
import rcs from "../Assets/rcs.png"
import weather from "../Assets/weather.png"
import portfolio from "../Assets/portfolio.png"
import tester from "../Assets/tester.png"
import bookstore from "../Assets/bookstore.png"
import littlelemon from "../Assets/littlelemon.png"

const Projects = () => {
  const [projects] = useState([
    { id: 1, title: 'MarieMadeIt', description: 'E-commerce Website', image: marie },
    { id: 2, title: 'Developer Portfolio', description: 'Interactive Project Showcase', image: portfolio },
    { id: 3, title: 'Rodgers Consulting Services', description: 'Modern Web Application', image: rcs },
    { id: 4, title: 'Weather App', description: 'API Integration', image: weather },
    { id: 5, title: 'Prestige Online Supply House', description: 'E-commerce Website', image: prestige },
    { id: 6, title: 'Book Haven Bookstore', description: 'Online Bookstore Project', image: bookstore },
    { id: 7, title: 'Little Lemon', description: 'Restaurant Website Project', image: littlelemon },
    { id: 8, title: 'MarieMadeIt Tester', description: 'Crochet Tester Application', image: tester },
  ])

  return (
    <main className='projects-container'>
      <div className='projects-scroll-wrapper'>
        <div className='projects-scroll'>
          {/* Original projects */}
          {projects.map((project) => (
            <div key={`original-${project.id}`} className='project-card'>
              <div className='project-image'><img src={project.image} alt={project.title} /></div>
              <div className='project-content'>
                <h3>{project.title}</h3>
                <p>{project.description}</p>
              </div>
            </div>
          ))}
          {/* Duplicated projects for infinite loop */}
          {projects.map((project) => (
            <div key={`duplicate-${project.id}`} className='project-card'>
              <div className='project-image'><img src={project.image} alt={project.title} /></div>
              <div className='project-content'>
                <h3>{project.title}</h3>
                <p>{project.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>
  )
}

export default Projects